import React, { useState, useEffect, useCallback } from 'react';
import './SettingsScreen.css';
import { blue } from '@mui/material/colors';
import { SideBarNavigation } from '../../components/SideBarNavigation/';
import { Grid, CssBaseline } from '@mui/material';
import { withStyles } from '@mui/styles';
import HeaderBar from './components/HeaderBar';
import GeneralInformationPanel from './components/GeneralInformationPanel';

const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: '#f5f5f5',
  },
  drawerText: {
    color: 'white',
    padding: 0,
  },
  content: {
    flexGrow: 1,
    padding: `${theme.spacing(2)} px`,
    marginLeft: 275,
    marginRight: 25,
  },
  toolbar: theme.mixins.toolbar,
  avatar: {
    color: '#fff',
    backgroundColor: blue[700],
    display: 'inline-flex',
  },
  searchBox: {
    width: '91.5%',
    margin: 'auto',
  },
  details: {
    flexDirection: 'column',
  },
});

const SettingsScreen = (props) => {
  const { token, provider, classes, logout, country_login } = props;

  const [expandedMode, setExpandedMode] = useState(false);
  const [saveStatus, setSaveStatus] = useState(null);
  const [showStatus, setShowStatus] = useState(false);

  useEffect(() => {
    document.title = 'Settings - Diet ID';
  }, []); //html page title

  const updateContentSize = useCallback((a) => {
    setExpandedMode(a);
  }, []);

  const showPopup = useCallback((status) => {
    if (status) {
      setSaveStatus(status);
      setShowStatus(true);
      setTimeout(() => {
        setShowStatus(false);
      }, 10);
    }
  }, []);

  return (
    <>
      <CssBaseline />
      <SideBarNavigation
        classes={classes}
        active="settings"
        provider={provider}
        passon={updateContentSize}
        logout={logout}
      />

      <main className={expandedMode ? classes.content + ' pageContent expanded' : classes.content + ' pageContent'}>
        <HeaderBar searchBox={classes.searchBox} />

        <br />
        <br />

        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="center"
          spacing={0}
          style={{ paddingTop: 0, marginTop: 20 }}
        >
          <GeneralInformationPanel
            classes={classes}
            provider={provider}
            country={country_login}
            token={token}
            showPopup={showPopup}
          />
        </Grid>

        {/*        <CustomMsgToast
        visible={showStatus}
        color={saveStatus === 'success' ? 'green' : 'red'}
        message={saveStatus === 'success' ? 'Settings Updated!' : saveStatus}
      />*/}
      </main>
    </>
  );
};

export default withStyles(styles)(SettingsScreen);
